/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { includes } from 'lodash/fp';
import { uniqueId } from '../../util/id';
import Selector from '../Selector';
/**
 * A group of Selectors.
 */
export function SelectorGroup({ options, onChange, value: activeValue, name: customName, label, multiple, ...props }) {
    const name = customName || uniqueId('selector-group_');
    return (React.createElement("div", Object.assign({ role: "group", "aria-label": label }, props), options &&
        options.map(({ children, value, ...rest }) => (React.createElement(Selector, Object.assign({ key: value }, { ...rest, value, name, onChange, multiple }, { checked: includes(value, activeValue) }), children)))));
}
